var _templateObject = _taggedTemplateLiteralLoose(['\n  position: absolute;\n  right: ', ';\n  bottom: ', ';\n'], ['\n  position: absolute;\n  right: ', ';\n  bottom: ', ';\n']),
  _templateObject2 = _taggedTemplateLiteralLoose(['\n  position: relative;\n  display: flex;\n  align-items: flex-start;\n  flex-basis: 50%;  \n  @media(min-width: 768px) and (max-width: 991.98px) {\n    ', '\n  } \n'], ['\n  position: relative;\n  display: flex;\n  align-items: flex-start;\n  flex-basis: 50%;  \n  @media(min-width: 768px) and (max-width: 991.98px) {\n    ', '\n  } \n']),
  _templateObject3 = _taggedTemplateLiteralLoose(['\n  position: relative;\n  width: 100%;\n  ', '   \n  div {\n    display: inline-block;\n  }\n'], ['\n  position: relative;\n  width: 100%;\n  ', '   \n  div {\n    display: inline-block;\n  }\n']);
function _taggedTemplateLiteralLoose(strings, raw) {
  strings.raw = raw;
  return strings;
}
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import ProfileImg from '../ProfileImage';
import { ProfileDataBox, ProfileWidgetBox } from './shared';
import Badge from '../Badge';
import { PlayIcon } from '../Icons';
var FloatingIcon = styled.div(_templateObject, function (_ref) {
  var vertical = _ref.vertical;
  return (vertical ? '-20' : '-70') + 'px';
}, function (_ref2) {
  var vertical = _ref2.vertical;
  return (vertical ? '-70' : '-25') + 'px';
});
var ProfileImgContainer = styled.div(_templateObject2, function (_ref3) {
  var square = _ref3.square;
  return square && 'flex-basis: 25%';
});
var MetaContainer = styled.div(_templateObject3, function (_ref4) {
  var square = _ref4.square;
  return square && 'position: absolute; left: 20px; bottom: 20px;';
});
var ProfileCard = function ProfileCard(_ref5) {
  var src = _ref5.src,
    onPhotoClick = _ref5.onPhotoClick,
    children = _ref5.children,
    vertical = _ref5.vertical,
    badge = _ref5.badge,
    playable = _ref5.playable,
    fluid = _ref5.fluid,
    square = _ref5.square;
  return React.createElement(ProfileWidgetBox, {
    vertical: vertical,
    fluid: fluid
  }, React.createElement(ProfileImgContainer, {
    square: square
  }, React.createElement(ProfileImg, {
    photo: src,
    fluid: fluid,
    square: square,
    onClick: onPhotoClick
  }, React.createElement(MetaContainer, {
    square: square
  }, badge ? React.createElement(Badge, {
    color: badge.color
  }, badge.text) : null, playable ? React.createElement(FloatingIcon, {
    vertical: vertical
  }, React.createElement(PlayIcon, null)) : null))), React.createElement(ProfileDataBox, {
    square: square
  }, children));
};
ProfileCard.displayName = 'ProfileCard';
ProfileCard.propTypes = process.env.NODE_ENV !== "production" ? {
  playable: PropTypes.bool,
  fluid: PropTypes.bool,
  vertical: PropTypes.bool,
  src: PropTypes.string,
  onPhotoClick: PropTypes.func,
  badge: PropTypes.shape({
    text: PropTypes.string,
    color: PropTypes.string
  })
} : {};
export default ProfileCard;